import { ITask } from '../types';

export default function workItemCompletionRatio(tasks: ITask[]): number {
  if (tasks.length === 0) {
    return 0;
  }

  const sumOfTasksProgress = tasks.reduce((memo, task) => {
    if (task.weight) {
      return memo + task.progress * (task.weight / 100);
    }

    return memo + task.progress / tasks.length;
  }, 0);

  return Math.floor(sumOfTasksProgress);
}
